import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { cellNotFilter, formatDateWithTimeCell, hasAllPermissions, hasPermission, useCheckPermissions, useTableFilter, useTableServerSideFiltering } from '@/shared';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { PermissionsEnum } from '@/auth/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';
import { ISubcategoriaIncidentes } from '@/shared/interfaces/erp/tickets-soporte-clientes';
import { useFetchSubcategoriaIncidencia, useUpdateSubcategoriaIncidencia } from '@/shared/actions/erp/subcategoria-incidentes';

const returnUrl = '/tickets-soporte-cliente/subcategoria-incidente';

export interface SubcategoriaIncidentePageInterface { }

const SubcategoriaIncidentePage: React.FC<SubcategoriaIncidentePageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_categoria_producto)

  const navigate = useNavigate();
  /* const updSate = useUpdateCategoryProduct({
    enableRedirect: false,
  }); */
  const updSate = useUpdateSubcategoriaIncidencia({
    enableRedirect: false,
  })
  ///* global state
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex } = pagination;
const {columnFilters, setColumnFilters, filterObject}=useTableServerSideFiltering()
  ///* fetch data
  const {
    data: categoriaIncidenciaPagingRes,
    isLoading,
    isRefetching,
  } = useFetchSubcategoriaIncidencia({
    page: pageIndex + 1,
    nombre: searchTerm,
    ...filterObject,
    FilterByState:false,
  });

  ///* mutations


  ///* handlers
  const onEdit = (original: ISubcategoriaIncidentes) => {
    navigate(`${returnUrl}/editar/${original.id_subcategoria_incidencia}`);
  };

  ///* columns
  const columns = useMemo<MRT_ColumnDef<ISubcategoriaIncidentes>[]>(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Código',
        size: 120,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
        size: 300,
      },
      {
        accessorKey: 'categoria_incidencia_nombre',
        header: 'Categoria Incidencia'
      },
      {
        ...cellNotFilter,
        accessorKey: 'fecha_creacion',
        header:'Fecha Creacion',
        Cell:({row})=> formatDateWithTimeCell(row, 'fecha_creacion')
      },
      {
       ...cellNotFilter,
       accessorKey:'fecha_modificacion',
       header:'Fecha Modificación',
       Cell:({row})=>formatDateWithTimeCell(row, 'fecha_modificacion')
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <SwitchComponente
              estadoSwitch={row.original.estado}
              titulo={row.original.estado ? 'Activo' : 'Inactivo'}
              setEstadoSwitch={state => {
                if (!hasPermission(PermissionsEnum.api_change_categoria_producto)) return;

                setConfirmDialog({
                  isOpen: true,
                  title: 'Cambiar Estado',
                  subtitle:
                    '¿Está seguro que desea cambiar el estado de esta categoria ?',
                  onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    updSate.mutate({
                      id: row.original.id_subcategoria_incidencia!,
                      data: { estado: !!state } as any,
                    });
                  },
                });
              }}
            />
          );
        },
      }
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Subcategoría Incidente" urlRedirect={`${returnUrl}/crear`}
      enableRedirect={hasPermission(PermissionsEnum.api_add_categoria_producto)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="Subcategoría Incidente"  cleanFilter={cleanFilter} />

      <GeneralTable<ISubcategoriaIncidentes>
        columns={columns}
        data={categoriaIncidenciaPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={categoriaIncidenciaPagingRes?.data?.count}
        // // actions
        actionsColumnSize={120}
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_categoria_producto,
        ])}
        //
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableManualFiltering={true}
        enableSorting={false}
        // crud
        onEdit={onEdit}
        canDelete={false}
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_categoria_producto,
        ])}
      />
    </SingleTableBoxScene>
  );
};

export default SubcategoriaIncidentePage;